import styled, { css } from 'styled-components';

interface InputLabelProps {
	isRequired?: boolean;
	isCompleted?: boolean;
}

export const InputLabel = styled.p<InputLabelProps>`
	margin-bottom: 8px;
	font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_md};
	text-decoration: ${({ isCompleted }) => (isCompleted ? 'line-through' : 'none')};
	color: ${({ isCompleted, theme }) =>
		isCompleted ? theme.palette.secondary['300'] : theme.palette.secondary['400']};

	${({ isRequired }) =>
		isRequired &&
		css`
			&::after {
				content: '*';
				color: ${({ theme }) => theme.colors.danger};
				margin-left: 5px;
			}
		`}
`;

export const TransparentButton = styled.button`
	padding: 0;
	border: none;
	display: flex;
	cursor: pointer;
	align-items: center;
	background: transparent;
	justify-content: center;

	&:hover {
		opacity: 0.8;
	}
`;
